export default __webpack_public_path__ + "static/media/mailchimp.1a46a0c8.png";